import {LEAGUES} from '../../constants/leagues';

// Своя иконка «явного» бота есть у каждой лиги: файлы bot_<лига>.png и
// bot_<лига>_black.png сверяет тест configs/leagues.test
const LEAGUES_WITH_ICON = new Set(Object.values(LEAGUES));

const DEFAULT_ICON_PATH = '/img/icons/bot.png';

/**
 * Иконка «явного» бота по его лиге. Путь выводится из самого id лиги, поэтому
 * новая лига потребует только файла, а не правки кода.
 *
 * Запасной вариант нужен старым записям матчей: там лиги у игрока может не
 * быть, а бот-иконку показать все равно надо.
 */
export const getVisibleBotIconPath = (leagueId, isBlackOutline) => (
  LEAGUES_WITH_ICON.has(leagueId) ? `/img/icons/bot_${leagueId}${isBlackOutline ? '_black' : ''}.png` : DEFAULT_ICON_PATH
);
